/**
 * Created by idea on 20/03/2017.
 */
import {Injectable} from '@angular/core';
import {Http} from '@angular/http';
import {Router} from '@angular/router';
import {ApiService} from './Api.service'
import {UploadService} from './Upload.service';
import {environment} from '../../../environments/environment';

@Injectable()
export class ProductService extends ApiService {
    constructor(http: Http, router: Router,private upload:UploadService) {
        super(http, router);
        this.setEndPoint('/products')
    }
    public updateVariants(product_id: string, data: any[]) {
        return this.put('/products/' + product_id + '/variants', data);
    }
    public productsByShop(data?: {}) {
        return this.get('/shops/products', data)
    }


    public getListProduct(status: boolean, page: any, page_size: any, body?: any) {
        if (status)
            return this.get("/products?page=" + page + "&page_size=" + page_size);
        else {
            var str = "";
            if (body.category_id)
                str += "&category_id=" + body.category_id;
            if (body.barcode)
                str += "&barcode=" + body.barcode;
            if (body.name)
                str += "&name=" + body.name;
            return this.get("/products?page=" + page + "&page_size=" + page_size + str);
        }

    }

    public publishVariant(product_id,variant_id,action,data?:any){
        return this.put(`/products/${product_id}/variants/${variant_id}/${action}`,data);
    }

    public getLinkShareProduct(body) {
        return this.post("/collaborators/product_sharing", body);
    }

    public getLinkShare(body) {
        return this.get("/collaborators/link_sharing", body);
    }


    public importExcel(file:File,postData?:any){
       return this.upload.postWithFile(`${environment.api}/products/import`,file,postData);
    }

    public getListProductByName(name){
        return this.get(`/products?name=${name}`);
    }

    public clone(id,data?:any){
        return this.get(`/products/${id}/clone`,data);
    }
}


// WEBPACK FOOTER //
// /app/src/app/common/services/Product.service.ts